import { Workspace } from "../../adapters/workspace";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  workspace: Workspace,
  repository: Repository,
): Interactor {
  return ({ account, planzone }) =>
    present(
      workspace
        .change(account, planzone)
        .then(() => repository.getUserHumanResource(account))
        .then((resource) => ({ account, planzone, resource }))
        .catch(() => Promise.reject({ account, planzone })),
    );
}

export type { Interactor };

export { createInteractor };
